import useCurrentMember from '@/member/hooks/useCurrentMember'
import {
  Thread_Activity_Type_Enum,
  useCreateThreadActivityMutation,
} from '@gql'
import { useCallback } from 'react'

export default function useCreateThreadMeetingNote() {
  const currentMember = useCurrentMember()
  const [createThreadActivity] = useCreateThreadActivityMutation()

  // Create the note, returns its id
  return useCallback(
    async (threadId: string, meetingId: string, notes: string) => {
      const { data } = await createThreadActivity({
        variables: {
          values: {
            threadId,
            memberId: currentMember?.id,
            type: Thread_Activity_Type_Enum.MeetingNote,
            refMeetingId: meetingId,
            data: {
              notes,
            },
          },
        },
      })
      return data?.insert_thread_activity_one?.id
    },
    [currentMember?.id]
  )
}
